import {AdminEntityService} from "./AdminEntityService";
import {ListResponse, ListRequest} from "../../../generated/protocol";
import {AppProperties, APP_PROPERTIES_NAME} from "../../AppProperties";
import {HttpService, HTTP_SERVICE_NAME} from "../http/HttpService";
import {AppCtx} from "../../ioc/ApplicationContext";
import {injectable, unmanaged} from "inversify";


@injectable()
export class AbstractAdminEntityService<E, V extends ListResponse> implements AdminEntityService<E> {
    http: HttpService;
    appProperties: AppProperties;
    entityPath: string;

    constructor(@unmanaged() entityPath: string) {
        this.http = AppCtx.resolve<HttpService>(HTTP_SERVICE_NAME);
        this.appProperties = AppCtx.resolve<AppProperties>(APP_PROPERTIES_NAME);
        this.entityPath = entityPath;
    }


    save(entity: E): Promise<E> {
        return this.http.doPost(this.entityPath, JSON.stringify(entity));
    }

    list(listRequest: ListRequest): Promise<V> {
        return this.http.doPost(this.entityPath + "/list", listRequest);
    }

    getEntity(id: string): Promise<E> {
        return this.http.doGet(this.entityPath + "/" + id);
    }

    remove(id: string): Promise<{}> {
        return this.http.doDelete(this.entityPath + "/" + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/service/admin/AbstractAdminEntityService.ts